import timeZonesEnam from '@/constant/timeZonesEnam';
import { getLinkToMeeting } from '@/helpers/new/getLinkToMeeting';
import { getDefaultTimezone } from '@/helpers/new/time/getDefaultTimezone';
import { timezoneOffsets } from '@/helpers/new/time/timezoneOffsets';
import moment from 'moment';

export const getNextReport = (reports, baseTimezone = timeZonesEnam.GMT_MINUS_3) => {
    const now = moment();
    
    const userTimezone = getDefaultTimezone();
    
    const userOffset = timezoneOffsets[userTimezone] || 3;
    const baseOffset = timezoneOffsets[baseTimezone] || 3;
    const offsetDiff = userOffset - baseOffset;
    let nextReport = null;
    let minTimeDiff = Infinity;
    
    reports.forEach(report => {
        if (!getLinkToMeeting({report})) return;
        
        const conferenceDateTime = moment(`${report.date_conference} ${report.start_time}`, 'YYYY-MM-DD HH:mm').clone().add(offsetDiff, 'hours');
        
        if (conferenceDateTime.isAfter(now)) {
            const timeDiff = conferenceDateTime.diff(now);
            
            if (timeDiff < minTimeDiff) {
                minTimeDiff = timeDiff;
                nextReport = report;
            }
        }
    });
      
    return nextReport;
}